import type { GroupBase } from 'models';
import { useTranslation } from 'react-i18next';
import { DataCard } from 'ui';
import { images } from 'common/utils';
import { useGetGroupPreviewIcon, useGetGroupPreviewTypeName } from '../../hooks';

type P = {
  getPathToGroupDetail: (id: string) => string;
  group: GroupBase;
  showTag?: boolean;
};

const GroupCard = ({ getPathToGroupDetail, group, showTag = true }: P) => {
  const { t } = useTranslation();
  const getGroupPreviewTypeName = useGetGroupPreviewTypeName();
  const getGroupPreviewIcon = useGetGroupPreviewIcon();

  return (
    <DataCard
      image={{
        alt: 'Group cover photo',
        src: group.coverPhoto?.url ?? images.default.groupCoverPhoto,
      }}
      participantsProperties={{
        count: group.membersCount,
        label: (formattedMembersCount) =>
          t('formattedMembersCount', { count: group.membersCount, formattedCount: formattedMembersCount }),
      }}
      path={getPathToGroupDetail(group.id)}
      tag={
        showTag
          ? {
              children: getGroupPreviewTypeName({ groupType: group.groupType }),
              icon: getGroupPreviewIcon({ groupType: group.groupType }),
            }
          : undefined
      }
      title={group.name}
    />
  );
};

export default GroupCard;
